import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL
}

const headers = () => ({
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
  token: localStorage.getItem('id_token'),
});

export function* getProductos(action) {
  const query = action.params ? '?' + new URLSearchParams(action.params).toString() : '';
  const res = yield gaxios.request({
    url: `api/erp/productos${query}`,
    headers: headers()
  });
  if (!res.data.success) {
    notification('error', res.data.msg)
  } else {
    yield put({
      type: actions.UPDATE_PRODUCTOS,
      productos: res.data.productos,
    });
  }
}

export function* getOpcionales(action) {
  console.log("Solicito opcionales");
  const res = yield gaxios.request({
    url: 'api/erp/productos/opcionales',
    headers: headers()
  });
  if (!res.data.success) {
    notification('error', res.data.msg)
  } else {
    yield put({
      type: actions.UPDATE_OPCIONALES,
      opcionales: res.data.opcionales,
    });
  }
}



export function* createProductos(action) {

  const res = yield gaxios.request({
    url: 'api/erp/productos',
    method: 'POST',
    data: action.data,
    headers: headers()
  });
  if (!res.data.success) {
    notification('error', res.data.msg)
  } else {
    notification('success', res.data.msg)
    if (action.history?.location?.pathname === '/dashboard/cotizar') {
      yield action.history.push('/dashboard/lista-cotizaciones');
    } else {
      yield put({ type: actions.GET_PRODUCTOS });
    }
  }
}

export function* editProducto(action) {
  const res = yield gaxios.request({
    url: 'api/erp/productos/' + action.data._id,
    method: 'PUT',
    data: action.data,
    headers: headers()
  });
  if (!res.data.success) {
    notification('error', res.data.msg)
  } else {
    notification('success', res.data.msg)
    yield put({ type: actions.GET_PRODUCTOS, });
  }
}

export function* deleteProducto(action) {
  const res = yield gaxios.request({
    url: 'api/erp/productos/' + action.id,
    method: 'DELETE',
    headers: headers()
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    notification('success', res.data.msg);
    yield put({ type: actions.GET_PRODUCTOS });
  }
}



export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_PRODUCTOS, getProductos),
    yield takeEvery(actions.CREATE_PRODUCTO, createProductos),
    yield takeEvery(actions.EDIT_PRODUCTO, editProducto),
    yield takeEvery(actions.DELETE_PRODUCTO, deleteProducto),
    yield takeEvery(actions.GET_OPCIONALES, getOpcionales),
  ]);
}
